export enum CtaSource {
	Layers = "layers",
	LockedLayer = "lockedLayer",
	ParcelCard = "parcelCard",
	ParcelField = "parcelField",
	ParcelReport = "parcelReport",
	RegulatoryAssistant = "regulatoryAssistant",
	WelcomeModal = "welcomeModal",
	LoginPage = "loginPage",
}

export function parseCtaSource(value: unknown): CtaSource | null {
	return Object.values(CtaSource).find(source => source === value) ?? null
}
